module.exports = Object.create(new Proxy({}, {
  get(_, key) {
    if (
      key !== '__esModule' &&
      key !== '__proto__' &&
      key !== 'constructor' &&
      key !== 'splice'
    ) {
      console.warn(`Module "https" has been externalized for browser compatibility. Cannot access "https.${key}" in client code.`)
    }
  }
}))